import React from 'react';
import { Box, Typography } from '@mui/material';

const HighlightedTextDisplay = ({ segments = [] }) => {
  return (
    <Box
      sx={{
        fontFamily: 'inherit',
        fontSize: 'inherit',
        lineHeight: 1.8,
        color: 'inherit'
      }}
    >
      {segments.map((segment, index) => {
        if (segment.isAdded) {
          return (
            <Box
              key={index}
              component="span"
              sx={{
                backgroundColor: '#90ee90',
                padding: '2px 4px',
                borderRadius: '3px',
                color: '#000',
                fontWeight: 500,
                margin: '0 1px'
              }}
            >
              {segment.text}
            </Box>
          );
        }
        
        return (
          <span key={index}>{segment.text}</span>
        );
      })}
    </Box>
  );
};

export default HighlightedTextDisplay;